import { render } from "./WClientes.vue?vue&type=template&id=cf2e4a00"
import script from "./WClientes.vue?vue&type=script&lang=js"
export * from "./WClientes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__